import { ROUTES } from './constants';

export function getRouteName(routeId: string): string {
  return ROUTES.find((route) => route.id === routeId)?.name ?? `Ruta ${routeId}`;
}

export function getDirectionLabel(direction: string): string {
  if (direction === 'litoral-santiago') {
    return 'Litoral central → Santiago';
  }
  return 'Santiago → Litoral central';
}

export function getDirectionShortLabel(direction: string): string {
  if (direction === 'litoral-santiago') {
    return 'Litoral → Stgo';
  }
  return 'Stgo → Litoral';
}

export function formatDateLong(dateYmd: string): string {
  const date = new Date(`${dateYmd}T00:00:00`);
  if (Number.isNaN(date.getTime())) {
    return dateYmd;
  }
  return date.toLocaleDateString('es-CL', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  });
}

export function formatDateShort(dateYmd: string): string {
  const date = new Date(`${dateYmd}T00:00:00`);
  if (Number.isNaN(date.getTime())) {
    return dateYmd;
  }
  return date.toLocaleDateString('es-CL', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function normalizeTime(timeValue: string): string {
  if (!timeValue) return '--:--';
  return timeValue.slice(0, 5);
}
